$(document).on('click', '.go_to_form', function(e) {
    e.preventDefault();
    $('html, body').animate({
        scrollTop: $('.col_form').offset().top
    }, 'slow');
});

$(document).on('click', '.greetings_bottom .more_details', function(e) {
    e.preventDefault();
    $.scrollTo('#how_to');
});
